import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { ProductInfoComponent } from '../../components/product-info/product-info.component';
import { RelatedProductComponent } from '../../components/related-product/related-product.component';
import { ActivatedRoute } from '@angular/router';
import { ContentService } from '../../services/content.service';
import { ProductService } from '../../services/product.service';
import { OffersInfoComponent } from '../../components/offers-info/offers-info.component';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, ProductInfoComponent, RelatedProductComponent, OffersInfoComponent],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {
  productInfo: any = null;
  constructor(private route: ActivatedRoute, 
    private contentService: ProductService) 
  {}

  ngOnInit() {


    
  //   this.route.params.subscribe((params: any) => {
  //     this.contentService.getProductBySku(params.id).subscribe((res:any ) => {
  //     this.productInfo = res;
  //     });
  //  });
  }

}
